<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card class="py-5">
          <v-toolbar flat>
            <v-col cols="12" class="px-0 py-5">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Daily Sales Report
                    <div class="month-label">
                      {{
                        `${formatDate(this.dates[0])} - ${formatDate(
                          this.dates[1]
                        )}`
                      }}
                      Report
                    </div>
                  </v-toolbar-title>
                </div>
                <div class="ml-auto d-flex">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="dates"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" v-bind="attrs" v-on="on">
                        <v-icon class="mr-2">mdi-calendar</v-icon> Choose Dates
                      </v-btn>
                    </template>
                    <v-date-picker v-model="dates" range>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(dates)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <v-select
                    :items="cities"
                    label="Select City"
                    dense
                    class="ml-2 mt-2"
                    v-model="currentCity"
                  ></v-select>
                </div>
              </div>
            </v-col>
            <!-- <v-spacer></v-spacer> -->
          </v-toolbar>

          <!-- <v-divider></v-divider> -->
        </v-card>
      </v-col>

      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Daily Sales Report
                  </v-toolbar-title>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import ShareableMethods from "@/mixins/ShareableMethods";
export default {
  mixins: [ShareableMethods],
  data() {
    return {
      currentCity: "All",
      cities: ["All"],
      dates: [
        moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        moment(this.date)
          .endOf("month")
          .format("YYYY-MM-DD"),
      ],
      menu: false,
      modal: false,
      search: "",
      table: {
        loading: false,
        headers: [
          {
            text: "Date",
            sortable: false,
            value: "date",
            // formatter: (x) => (x ? moment(x).format("MMM DD") : null),
          },
          {
            text: "Online Payment",
            sortable: false,
            value: "paymaya",
            formatter: (x) => this.setToLocaleString(x),
          },
          {
            text: "Retailer",
            sortable: false,
            value: "retailer",
            formatter: (x) => this.setToLocaleString(x),
          },
          // {
          //   text: "Sign-up / Install",
          //   sortable: false,
          //   value: "signupInstall",
          //   formatter: (x) => this.setToLocaleString(x),
          // },
          // {
          //   text: "Voucher",
          //   sortable: false,
          //   value: "voucher",
          //   formatter: (x) => this.setToLocaleString(x),
          // },
          {
            text: "Total",
            sortable: false,
            value: "total",
            formatter: (x) => this.setToLocaleString(x),
          },
        ],
        data: [],
      },
    };
  },

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$api
        .get(
          `/acquisition/report?report=dailySales&startDate=${
            this.dates[0]
          }&endDate=${this.dates[1]}&city=${
            this.currentCity == "All" ? "" : this.currentCity
          }`
        )
        .then((response) => {
          const newArr = response.data.data;
          this.table.data = newArr.dailySales;

          newArr.cities.forEach((city) => {
            this.cities.push(city);
          });

          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    formatDate(d) {
      return moment(d).format("MMM DD, YYYY");
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    dates() {
      this.getList();
    },
    currentCity() {
      this.getList();
    },
  },

  computed: {
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
